import {LabelType, Options} from '@angular-slider/ngx-slider';
import {moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {formatDate} from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {EChartsOption} from 'echarts';
import {Subscription} from 'rxjs';
import {ModalsComponent} from 'src/app/components/modals/modals.component';
import {ApiwrapperService} from 'src/app/services/apiwrapper.service';
import {ChallengesService} from 'src/app/services/challenges.service';
import {DataManipulationService} from 'src/app/services/data-manipulation.service';
import {Block} from 'notiflix/build/notiflix-block-aio';
import demo from "../../../assets/data/demo.json"
import {TranslateService} from '@ngx-translate/core';
import {
  PyramidCategory,
  PyramidLegendItem
} from 'src/app/components/categories-pyramid-display/categories-pyramid-display.component';
import {Dropdown} from 'primeng/dropdown';

@Component({
  selector: 'app-workspace-overview',
  templateUrl: './workspace-overview.component.html',
  styleUrls: ['./workspace-overview.component.scss']
})
export class WorkspaceOverviewComponent implements OnInit {
  @ViewChild('teamDynamicPeriodDropdown') teamDynamicPeriodDropdown: Dropdown | undefined;
  knobProgress: number = 0;
  workspaceTeams: any = [];
  showIndicators: boolean = false;
  dropdownOptions: { name: string, value: number }[];
  teamSortType = '';
  teamScoreSelector = 0;

  optionPie: EChartsOption = {
    tooltip: {
      trigger: 'none'
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: '50%',
        avoidLabelOverlap: false,
        label: {
          show: true,
        },

        color: ['#F78C02', '#1AC487'],
        emphasis: {
          label: {
            show: true,
            fontSize: 20,
            fontFamily: 'Poppins',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          {value: 0, name: 'Pending'},
          {value: 0, name: 'Active'}
        ]
      }
    ]
  };

  chartOption: EChartsOption = {
    xAxis: {
      type: 'category',
      axisLabel: {
        color: '#000000',
        fontWeight: 400,
      },
      data: [],
    },
    yAxis: {
      type: 'value',
      max: 100,
      min: 0,
      axisLabel: {
        color: '#000000',
        fontWeight: 400,
      },
    },
    tooltip: {
      trigger: 'axis'
    },
    series: [
      {
        name: 'Success Score',
        label: {
          // @ts-ignore
          normal: {
            show: false,
            position: 'top'
          },
        },
        data: [],
        type: 'line',
        symbolSize: 10,
        smooth: true,
        color: '#19AEFF',
        // emphasis: {
        //   focus: 'series'
        // },
        tooltip: {
          trigger: 'axis',
        },
      },
      {
        name: 'Response Rate',
        label: {
          // @ts-ignore
          normal: {
            show: false,
            position: 'top'
          },
        },
        data: [],
        tooltip: {
          trigger: 'axis',
        },
        type: 'line',
        symbolSize: 0,
        lineStyle: {
          color: '#FF764C',
          width: 2,
        },
        smooth: true,
        color: '#FF764C',
        // emphasis: {
        //   focus: 'series'
        // },
      },
    ],
  };
  indicator = {
    successteamScore: '../../../assets/svg/overall-white.svg',
    successteamScoreChart: '../../../assets/svg/overall-lightblue.svg',
    performance: '../../../assets/svg/performance-white.svg',
    performanceChart: '../../../assets/svg/performance-icon-lightblue.svg',
    motivation: '../../../assets/svg/motivation-white.svg',
    motivationChart: '../../../assets/svg/motivation-icon-lightblue.svg',
    satisfaction: '../../../assets/svg/satisfaction-white.svg',
    satisfactionChart: '../../../assets/svg/satisfaction-icon-lightblue.svg',
    stress: '../../../assets/svg/stress-white.svg',
    stressChart: '../../../assets/svg/stress-icon-lightblue.svg'
  };

  indicatorBackground = {
    Performance: this.data.colors.greyGradient,
    Motivation: this.data.colors.greyGradient,
    Satisfaction: this.data.colors.greyGradient,
    Stress: this.data.colors.greyGradient,
  };

  codexIndicatorBackground: { [key: string]: string } = {
    'empower-people': this.data.colors.greyGradient,
    'be-present-&-helpful': this.data.colors.greyGradient,
    'be-transparent': this.data.colors.greyGradient,
    'be-inspirational': this.data.colors.greyGradient,
    'set-a-clear-direction': this.data.colors.greyGradient,
  }

  showPie: boolean = true;
  members = {
    total: 0,
    active: 0,
    pending: 0
  }
  totalTeams = 0;
  showTrends: boolean = false;
  chartType: string = '';
  showChart: boolean = true;

  scoreColorInterval = {
    "red": {"min": 0, "max": 39},
    "orange": {"min": 40, "max": 59},
    "yellow": {"min": 60, "max": 79},
    "green": {"min": 80, "max": 100}
  };
  knobColor: string = this.data.colors.grey;
  codexKnobColor: string = this.data.colors.grey;

  workspaceResults: any = {
    latestReport: {
      Motivation: 0,
      Performance: 0,
      Satisfaction: 0,
      Stress: 0,
      responseRate: 0,
      workspaceSuccessteamScore: 0
    },
    previousReport: {
      Motivation: 0,
      Performance: 0,
      Satisfaction: 0,
      Stress: 0,
      responseRate: 0,
      workspaceSuccessteamScore: 0
    }
  };
  private graph: any;
  public graphType = {
    type: '',
    title: '',
    showResponse: true
  };
  public gotAlert: boolean = false;
  public workspaceAlerts: any[] = [];
  gotMultipleAlerts: boolean = false;
  language = '';
  eligibleForTrends: any;
  workspaceTrends: any;
  workspaceCurrentTrendReport: any;
  workspacePreviousTrendReport: any;
  workspaceNextTrendReport: any;
  trendsProgressBarWidth: any;
  selectedTrendDate: any;
  progressBarPercentage: any;
  trendReportDaysRemaining: any;
  hideCover: boolean = false;
  startDateForNextReport: any;
  teamDynamic: any = null;
  teamDynamicCategories: PyramidCategory[] = [];
  teamDynamicLegend: PyramidLegendItem[] = [];
  teamDynamicPeriod: 'all' | 'custom' = 'all';
  teamDynamicPeriodLabel: string = '';
  teamDynamicPeriodOptions: { label: string, value: string }[] = [];
  showTeamDynamicCalendar: boolean = false;
  teamDynamicRangeDates: Date[] | null = null;
  private teamDynamicIcons: { [key: string]: string } = {
    trust: 'trust-icon.svg',
    conflict: 'conflict-icon.svg',
    commitment: 'commitment-icon.svg',
    accountability: 'accountability-icon.svg',
    results: 'results-icon.svg'
  };
  // apex first, used to keep the pyramid on screen while the workspace has no report yet
  private teamDynamicPlaceholders = [
    {icon: 'results', label: 'custom_poll_temp_dysfunctional_results'},
    {icon: 'accountability', label: 'custom_poll_temp_dysfunctional_accountability'},
    {icon: 'commitment', label: 'custom_poll_temp_dysfunctional_commitment'},
    {icon: 'conflict', label: 'custom_poll_temp_dysfunctional_conflicts'},
    {icon: 'trust', label: 'custom_poll_temp_dysfunctional_trust'}
  ];

  codexReports: any;
  codex: any = {
    showCodex: false,
    current: {},
    previous: {},
    selector: [],
    hasPrevious: true,
  };

  constructor(private activeRoute: ActivatedRoute, public data: DataManipulationService, public router: Router,
              public challengesService: ChallengesService, public modal: ModalsComponent,
              public api: ApiwrapperService, private translate: TranslateService) {
    this.dropdownOptions = [
      {name: this.translate.instant('wo_sort_today'), value: 0},
      {name: this.translate.instant('wo_sort_30_ago'), value: 30},
      {name: this.translate.instant('wo_sort_90_ago'), value: 90}
    ];
    this.codex.showCodex = false;
  }

  ngOnInit() {
    //@ts-ignore
    this.language = JSON.parse(localStorage.getItem('userDetails')).detail.preferredLanguage.tag;
    //@ts-ignore
    this.workspaceNextTrendReport = JSON.parse(localStorage.getItem('WORKSPACE')).nextTrendReportDate;
    this.getColors();
    this.teamSort('score');
    this.getWorkspaceMembers();
    this.getWorkspaceIndicators();
    this.getWorkspaceGraph();
    this.getWorkspaceTrends();
    this.getWorkspaceAlters();
    this.setTeamDynamicLegend();
    this.setTeamDynamicPeriodOptions();
    this.setTeamDynamicPeriodLabel();
    this.getWorkspaceTeamDynamic();
    this.data.showLoading();
  }

  getColors() {
    this.api.getIndicatorInterval().subscribe(
      res => {
        //@ts-ignore
        res.forEach(el => {
          // @ts-ignore
          this.scoreColorInterval[el.indicatorColor.color].min = el.min;
          // @ts-ignore
          this.scoreColorInterval[el.indicatorColor.color].max = el.max;
        });
        this.mapTeamDynamicCategories();
      }
    );
  }

  setKnobProgressBar(value: any, element: string) {
    if (document.getElementById(element)) {
      this.knobProgress = Math.round((184 - (184 * value) / 100));
      //@ts-ignore
      document.getElementById(element).style.strokeDashoffset = this.knobProgress.toString();
    } else {
      setTimeout(() => {
        this.setKnobProgressBar(value, element)
      }, 200);
    }
  }

  getWorkspaceIndicators() {
    this.api.getWorkspaceIndicators().subscribe(
      res => {
        // get the workspace indicators data
        this.workspaceResults = res;
        this.sortColors();
        this.getCodex();
      }
    )
  }

  sortColors() {
    Object.keys(this.workspaceResults.latestReport).forEach((el: any, index) => {
      Object.keys(this.scoreColorInterval).forEach((color: any) => {
        // @ts-ignore
        const interval = this.scoreColorInterval[color];
        const value = this.workspaceResults.latestReport[el];
        if (value >= interval.min && value <= interval.max) {
          if (el === 'workspaceSuccessteamScore') {
            // @ts-ignore
            this.knobColor = this.data.colors['' + color];
          } else {
            // @ts-ignore
            this.indicatorBackground['' + el] = this.data.colors['' + color + 'Gradient'].toString();
          }
        } else if (value === 0) {
          // @ts-ignore
          this.indicatorBackground['' + el] = this.data.colors['greyGradient'].toString();
          // @ts-ignore
        }
      })
    });
    this.showIndicators = true;
    this.data.hideLoading();
  }

  getWorkspaceGraph() {
    this.api.getWorkspaceGraph().subscribe(
      res => {
        this.graph = res;
        this.changeChart('score', 'Success Score', true);
      }
    )
  }

  getWorkspaceTrends() {
    this.api.getWorkspaceTrends().subscribe(
      (res: any) => {
        this.workspaceTrends = res._embedded["workspace-trend-reports"];
        this.workspaceTrends.dates = [];
        if (this.workspaceTrends.length) {
          this.workspaceCurrentTrendReport = this.workspaceTrends[0];
          this.workspaceCurrentTrendReport.botTrends = this.workspaceCurrentTrendReport?.botTrends.sort((a: any, b: any) => {
            return a.score < b.score ? -1 : 1;
          });
          if (this.workspaceTrends.length >= 2) {
            this.workspacePreviousTrendReport = this.workspaceTrends[1];
            this.getTrendsStatusAndScore();
          }
          this.formatTrendReportsDates();
          this.hideCover = true;
          this.showTrends = true;
        } else if (this.workspaceTrends.length === 0 && this.workspaceNextTrendReport) {
          this.getTrendsProgressAndDates(this.workspaceNextTrendReport.date);
          this.workspaceCurrentTrendReport = demo.trends;
          //this.eligibleForTrends = workspaceCurrentTrendReport.eligibleForNextReport;
          this.hideCover = false;
          this.showTrends = true;
        }
      }
    );
  }

  getTrendsProgressAndDates(endDate: Date) {
    const today = new Date().getTime();
    const end = new Date(endDate).getTime();
    this.trendReportDaysRemaining = Math.floor((end - today) / 1000 / 60 / 60 / 24);
    this.progressBarPercentage = Math.floor(((90 - this.trendReportDaysRemaining) / 90) * 100) + '%';
    this.startDateForNextReport = new Date(new Date().setDate(new Date().getDate() - (90 - this.trendReportDaysRemaining)));
  }

  formatTrendReportsDates() {
    this.workspaceTrends.forEach((report: any, index: number) => {
      this.workspaceTrends.dates.push({
        date: formatDate(report.startDate.date, 'dd.MM.yyyy', 'en-US') + ' - ' + formatDate(report.endDate.date, 'dd.MM.yyyy', 'en-US'),
        index: index
      });
    });
    this.hideCover = true;
    this.showTrends = true;
  }

  getTrendsStatusAndScore() {
    const currentTrends = [...this.workspaceCurrentTrendReport.topTrends, ...this.workspaceCurrentTrendReport.botTrends];
    currentTrends.forEach((currentReport: any) => {
      let topTrend = this.searchInTopTrends(currentReport);
      let botTrend = this.searchInBotTrends(currentReport);
      if (topTrend.scorePreview !== '') {
        currentReport.scorePreview = topTrend.scorePreview;
      } else if (botTrend.scorePreview !== '') {
        currentReport.scorePreview = botTrend.scorePreview;
      } else {
        currentReport.isNew = true;
      }
    });
  }

  searchInTopTrends(currentReport: any) {
    let trendStats = {scorePreview: ''};
    this.workspacePreviousTrendReport.topTrends.forEach((trend: any) => {
      if (currentReport.category.uuid === trend.category.uuid) {
        trendStats = {scorePreview: currentReport.score > trend.score ? 'up' : currentReport.score < trend.score ? 'down' : 'even'};
      }
    });
    return trendStats;
  }

  searchInBotTrends(currentReport: any): any {
    let trendStats = {scorePreview: ''};
    this.workspacePreviousTrendReport.botTrends.forEach((trend: any) => {
      if (currentReport.category.uuid === trend.category.uuid) {
        trendStats = {scorePreview: currentReport.score > trend.score ? 'up' : currentReport.score < trend.score ? 'down' : 'even'};
      }
    });
    return trendStats;
  }

  changeTrendDate(event: any) {
    this.workspaceCurrentTrendReport = this.workspaceTrends[event.value.index];
    if (event.value.index + 1 < this.workspaceTrends.length) {
      this.workspacePreviousTrendReport = this.workspaceTrends[event.value.index + 1];
      this.getTrendsStatusAndScore();
    }
  }

  changeChart(type: string, title: string, showResponse: boolean) {
    const lang = this.language.toLowerCase() === 'en_us' ? 'EN' : 'DK';
    switch (title) {
      case 'Satisfaction':
        title = lang === 'EN' ? 'Satisfaction' : 'Tilfredshed';
        break;
      case 'Stress Free':
        title = lang === 'EN' ? 'Stress Free' : 'Stressfri';
        break;
    }
    this.graphType = {type: type, title: title, showResponse: showResponse}
    // @ts-ignore
    this.chartOption.series[0].name = title;
    // @ts-ignore
    this.chartOption.series[1].name = lang === 'EN' ? 'Response Rate' : 'Svarprocent';
    // @ts-ignore
    this.chartOption.series[0].data = [];
    // @ts-ignore
    this.chartOption.series[1].data = [];
    // @ts-ignore
    this.chartOption.xAxis.data = [];
    this.graph.forEach((el: any) => {
      // @ts-ignore
      this.chartOption.xAxis.data.push(formatDate(el.created.date, 'dd MMM', 'en-US'));
      // @ts-ignore
      this.chartOption.series[0].data.push({value: el[type], name: formatDate(el.created.date, 'dd MMM', 'en-US')});
      if (showResponse) {
        // @ts-ignore
        this.chartOption.series[1].data.push({
          value: el.responseRate,
          name: lang === 'EN' ? 'Response Rate' : 'Svarprocent'
        });
      }
    })
    this.showChart = !this.showChart;
  }

  getWorkspaceMembers() {
    this.api.getWorkspaceUsersStatistic().subscribe(
      res => {
        this.members.total = res.totalMembers;
        this.members.active = res.activeMembers;
        this.members.pending = res.inactiveMembers;
        // @ts-ignore
        this.optionPie.series[0].data[0].value = this.members.pending;
        // @ts-ignore
        this.optionPie.series[0].data[1].value = this.members.active;
        this.showPie = !this.showPie;
      }
    )
  }

  teamSort(type: string) {
    Block.circle('#teamsRanking', {
      svgColor: 'rgba(0,189,130)'
    });
    // this.startDate, 'dd-MM-yyyy', 'en-US'), formatDate(this.endDate, 'dd-MM-yyyy', 'en-US')
    this.teamSortType = type;
    let endDate;
    if (this.teamScoreSelector !== 0) {
      let now = new Date();
      endDate = formatDate(new Date(now.setDate(now.getDate() - this.teamScoreSelector)), 'dd-MM-yyyy', 'en-US');
    } else {
      endDate = formatDate(new Date(), 'dd-MM-yyyy', 'en-US');
    }

    this.api.getTeamsRanking(type, endDate).subscribe(
      res => {
        this.totalTeams = res.totalTeams;
        // this.workspaceTeams = res;
        if (res.botTeam !== null) {
          let teams = res.topTeams.concat(res.botTeam)
          teams.forEach((el: any) => {
            // add the report to the team
            this.api.getTeamReport(el.uuid).subscribe(res => {
              el.teamReport = res
              switch (type) {
                case  'score':
                  el.reporting = el?.teamReport?.teamSuccessteamScore
                  break;
                case  'responseRate':
                  el.reporting = el?.teamReport?.responseRate
                  break
                case  'LeadershipScore':
                  el.reporting = el?.teamReport?.LeadershipScore
                  break
                case  'TeamScore':
                  el.reporting = el?.teamReport?.TeamScore
                  break
              }
            }, err => {
            });
          })
          this.workspaceTeams = teams;
        }
        Block.remove('#teamsRanking');
      }, err => {
        console.log(err)
      })
  }

  private getWorkspaceAlters() {
    this.api.getWorkspaceAlerts().subscribe((res: any) => {
        this.workspaceAlerts = res._embedded["workspace-alerts"];
        if (this.workspaceAlerts.length) {
          if (this.workspaceAlerts.length > 1) {
            this.gotMultipleAlerts = true;
          }
          this.gotAlert = true;
        }
      }
    )
  }

  goToWorkspaceMembers() {
    this.data.settingsWorkspaceMembers = true;
    this.router.navigate(['/settings/workspace']);
  }

  getStatementsSelector(value: any) {
    this.teamScoreSelector = value.value;
    this.teamSort(this.teamSortType);
  }

  private getCodex() {
    this.api.getCodex().subscribe((res: any) => {
      // set the current codex and the previous one
      let reports = res._embedded.reports.sort((a:any, b:any) => new Date(b.startDate.date).getTime() - new Date(a.startDate.date).getTime());
      this.codexReports = reports;

      reports.forEach((report: any, index: number) => {
        this.codex.selector.push({
          label: report.label,
          index
        })
      })
      this.sortReports(0);
    })
  }

  sortReports(i: number) {
    if (this.codexReports.length > 0) {
      this.codexReports[i].topics = [...this.codexReports[i].topics].sort((a, b) => b.score - a.score)
      this.codexReports[i].mappedTopics = this.mapTopicsByCategory(this.codexReports[i].topics);
      this.codex.current = this.codexReports[i];
      if (this.codexReports[i+1]) {
        this.codexReports[i+1].topics = [...this.codexReports[i+1].topics].sort((a, b) => b.score - a.score)
        this.codexReports[i+1].mappedTopics = this.mapTopicsByCategory(this.codexReports[i+1].topics);
        this.codex.previous = this.codexReports[i+1];
        this.codex.hasPrevious = true;
      } else {
        this.codex.hasPrevious = false;
      }

      this.codex.current.topics.forEach((el: any) => {
        Object.keys(this.scoreColorInterval).forEach((color: any) => {
          // @ts-ignore
          const interval = this.scoreColorInterval[color];
          if (this.codex.current.score >= interval.min && this.codex.current.score <= interval.max) {
            // @ts-ignore
            this.codexKnobColor = this.data.colors['' + color];
          }
          if (el.score >= interval.min && el.score <= interval.max) {
            // @ts-ignore
            this.codexIndicatorBackground['' + el.category.slug] = this.data.colors[color + 'Gradient'].toString();
          } else if (el.score === 0) {
            // @ts-ignore
            this.codexIndicatorBackground['' + el.category.slug] = this.data.colors['greyGradient'].toString();
          }
        })
      })
      this.codex.showCodex = true;
    }
  }

  mapTopicsByCategory = (topics: any[]) => {
    return topics.reduce((acc: any, topic: any) => {
      const uuid = topic.category?.uuid;
      if (!uuid) return acc;
      acc[uuid] = topic;
      return acc;
    }, {});
  };

  getWorkspaceTeamDynamic(startDate?: any, endDate?: any) {
    this.api.getWorkspaceTeamDynamic(startDate, endDate).subscribe((res: any) => {
      this.teamDynamic = res && !res.error ? res : null;
      this.mapTeamDynamicCategories();
    })
  }

  mapTeamDynamicCategories() {
    const details = this.teamDynamic?.current?.details;
    if (!details?.length) {
      this.setTeamDynamicEmptyState();
      return;
    }
    const previousScores = this.mapTeamDynamicPreviousScores();
    this.teamDynamicCategories = [...details].reverse().map((detail: any) => {
      const collection = detail.timedQuestionCollection;
      const score = detail.score ?? 0;
      const color = this.getScoreIntervalColor(score);
      return {
        uuid: collection?.uuid,
        title: (collection?.title ?? '').trim(),
        score,
        icon: this.getTeamDynamicIcon(collection?.slug),
        // @ts-ignore
        color: this.data.colors['' + color],
        // @ts-ignore
        gradientColor: this.data.colors['' + color + 'Gradient'],
        trend: this.getTeamDynamicTrend(score, previousScores[collection?.uuid])
      };
    });
  }

  private setTeamDynamicEmptyState() {
    this.teamDynamicCategories = this.teamDynamicPlaceholders.map(placeholder => ({
      uuid: placeholder.icon,
      title: this.translate.instant(placeholder.label),
      score: 0,
      icon: '../../../assets/icons/5D/' + this.teamDynamicIcons[placeholder.icon],
      color: this.data.colors.grey,
      gradientColor: this.data.colors.greyGradient,
      trend: null
    }));
  }

  private mapTeamDynamicPreviousScores(): { [key: string]: number } {
    return (this.teamDynamic?.previous?.details ?? []).reduce((acc: any, detail: any) => {
      const uuid = detail.timedQuestionCollection?.uuid;
      if (uuid) {
        acc[uuid] = detail.score;
      }
      return acc;
    }, {});
  }

  private getTeamDynamicTrend(score: number, previousScore: number | undefined): 'up' | 'down' | null {
    if (previousScore === undefined || previousScore === null || score === previousScore) {
      return null;
    }
    return score > previousScore ? 'up' : 'down';
  }

  private getScoreIntervalColor(score: number): string {
    if (!score) {
      return 'grey';
    }
    const color = Object.keys(this.scoreColorInterval).find((key: any) => {
      // @ts-ignore
      const interval = this.scoreColorInterval[key];
      return score >= interval.min && score <= interval.max;
    });
    return color ?? 'grey';
  }

  private getTeamDynamicIcon(slug: string | undefined): string {
    const key = slug ? Object.keys(this.teamDynamicIcons).find(name => slug.includes(name)) : undefined;
    return key ? '../../../assets/icons/5D/' + this.teamDynamicIcons[key] : '';
  }

  setTeamDynamicLegend() {
    this.teamDynamicLegend = [
      {label: this.translate.instant('wo_team_dynamic_legend_strong'), color: this.data.colors.green},
      {label: this.translate.instant('wo_team_dynamic_legend_moderate'), color: this.data.colors.yellow},
      {label: this.translate.instant('wo_team_dynamic_legend_attention'), color: this.data.colors.orange},
      {label: this.translate.instant('wo_team_dynamic_legend_critical'), color: this.data.colors.red}
    ];
  }

  setTeamDynamicPeriodOptions() {
    this.teamDynamicPeriodOptions = [
      {label: this.translate.instant('custom_poll_main_reporting_all_time'), value: 'all'},
      {label: this.translate.instant('wo_team_dynamic_custom_period'), value: 'custom'}
    ];
  }

  setTeamDynamicPeriodLabel() {
    const range = this.teamDynamicRangeDates;
    this.teamDynamicPeriodLabel = this.teamDynamicPeriod === 'custom' && range?.length === 2 ?
      formatDate(range[0], 'dd.MM.yyyy', 'en-US') + ' - ' +
      formatDate(range[1], 'dd.MM.yyyy', 'en-US') :
      this.translate.instant('custom_poll_main_reporting_all_time');
  }

  onTeamDynamicPeriodChange(event: any) {
    if (event.value === 'all') {
      this.selectTeamDynamicAllTime();
    }
  }

  selectTeamDynamicAllTime() {
    this.teamDynamicPeriod = 'all';
    this.teamDynamicRangeDates = null;
    this.setTeamDynamicPeriodLabel();
    this.showTeamDynamicCalendar = false;
    this.getWorkspaceTeamDynamic();
  }

  submitTeamDynamicRange() {
    const range = this.teamDynamicRangeDates;
    if (!range || range.length !== 2 || !range[1]) {
      return;
    }
    this.teamDynamicPeriod = 'custom';
    this.setTeamDynamicPeriodLabel();
    this.teamDynamicPeriodDropdown?.hide();
    this.getWorkspaceTeamDynamic(
      formatDate(range[0], 'dd.MM.yyyy', 'en-US'),
      formatDate(range[1], 'dd.MM.yyyy', 'en-US')
    );
  }

  clearTeamDynamicRange() {
    this.teamDynamicRangeDates = null;
  }

  cancelTeamDynamicRange() {
    this.clearTeamDynamicRange();
    this.teamDynamicPeriodDropdown?.hide();
  }

  onTeamDynamicCategory(category: PyramidCategory) {
    this.router.navigate(['/team-dynamics-reporting'], {queryParams: {category: category.uuid}});
  }
}
